const PASTAEL_GIFT_POPUP_PROPERTY = '_free_gift';
const PASTAEL_GIFT_POPUP_PROPERTY_VALUE = 'drawstring_bag';

function pastaelFormatGiftRemainingText(template, remaining) {
  if (!template) return '';
  const setSuffix = Number(remaining) === 1 ? '' : 's';
  return template.replaceAll('__COUNT__', String(remaining)).replaceAll('__SET_SUFFIX__', setSuffix);
}
const PASTAEL_GIFT_POPUP_AUTO_KEY = 'pastael-gift-popup-auto-shown';
if (!customElements.get('pastael-gift-popup')) {
  customElements.define(
    'pastael-gift-popup',
    class PastaelGiftPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-gift-popup-dialog]');
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.wasUnlocked = this.hasAttribute('data-unlocked');

        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onDocumentKeydown = this.onDocumentKeydown.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
        this.onDialogClick = this.onDialogClick.bind(this);
        this.onDialogClose = this.onDialogClose.bind(this);
        this.onAddClick = this.onAddClick.bind(this);
        this.onSwatchChange = this.onSwatchChange.bind(this);
        this.onCartUpdate = this.onCartUpdate.bind(this);

        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onDocumentKeydown);
        this.querySelector('[data-gift-popup-close]')?.addEventListener('click', this.onCloseClick);
        this.dialog?.addEventListener('click', this.onDialogClick);
        this.dialog?.addEventListener('close', this.onDialogClose);
        this.querySelector('[data-gift-popup-add]')?.addEventListener('click', this.onAddClick);
        this.querySelector('[data-gift-picker]')?.addEventListener('change', this.onSwatchChange);

        const pubSubEvents = window.PUB_SUB_EVENTS;
        if (typeof subscribe === 'function' && pubSubEvents?.cartUpdate) {
          this.cartUnsubscriber = subscribe(pubSubEvents.cartUpdate, this.onCartUpdate);
        }

        this.syncBagSizeFromPdp().finally(() => {
          this.enableSwatches();
          this.selectDefaultSwatch();
          this.updateVariantUi();
        });
        this.refreshFromCart({ autoOpen: false });
      }

      enableSwatches() {
        this.querySelectorAll('[data-gift-swatches] input[type="radio"]').forEach((input) => {
          if (typeof PastaelFreeGift !== 'undefined') {
            PastaelFreeGift.enableGiftSwatchInput(input);
            return;
          }
          input.hidden = false;
          input.disabled = false;
          input.removeAttribute('hidden');
          input.removeAttribute('disabled');
          input.classList.remove('visually-disabled');
          const label = input.nextElementSibling;
          if (label?.matches?.('label')) {
            label.hidden = false;
            label.removeAttribute('hidden');
          }
        });
      }

      syncBagSizeFromPdp() {
        const picker = this.querySelector('[data-gift-picker]');
        if (!picker || typeof PastaelFreeGift === 'undefined' || !PastaelFreeGift.isGiftSizeDynamic(picker)) {
          return Promise.resolve();
        }

        const pdp = document.querySelector('pastael-pdp');
        if (pdp?.collectThresholdGiftCubeSizeLabels) {
          return pdp
            .collectThresholdGiftCubeSizeLabels()
            .then((labels) => {
              PastaelFreeGift.syncGiftSizeFilter(picker, labels);
              PastaelFreeGift.updateGiftVariantUi(picker);
            })
            .catch(() => {});
        }

        const qualifyingLabel = document.querySelector('[data-gift-progress]')?.dataset?.qualifyingSizeLabel;
        if (qualifyingLabel) {
          PastaelFreeGift.syncGiftSizeFilter(picker, [qualifyingLabel]);
          PastaelFreeGift.updateGiftVariantUi(picker);
        }
        return Promise.resolve();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onDocumentKeydown);
        this.cartUnsubscriber?.();
      }

      get threshold() {
        const pdp = document.querySelector('[data-gift-progress]');
        return Number(pdp?.dataset.threshold || this.dataset.threshold || 0);
      }

      get productIds() {
        const pdp = document.querySelector('[data-gift-progress]');
        return this.splitList(pdp?.dataset.productIds || this.dataset.productIds);
      }

      get productHandles() {
        const pdp = document.querySelector('[data-gift-progress]');
        return this.splitList(pdp?.dataset.productHandles || this.dataset.productHandles);
      }

      splitList(value) {
        return String(value || '')
          .split(',')
          .map((item) => item.trim())
          .filter(Boolean);
      }

      onDocumentClick(event) {
        const trigger = event.target.closest('[data-gift-progress], [data-gift-popup-open]');
        if (!trigger) return;
        if (event.target.closest('[data-gift-swatches]')) return;
        event.preventDefault();
        this.open();
      }

      onDocumentKeydown(event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const trigger = event.target.closest('[data-gift-progress], [data-gift-popup-open]');
        if (!trigger || event.target.closest('[data-gift-swatches]')) return;
        event.preventDefault();
        this.open();
      }

      onCloseClick(event) {
        event.preventDefault();
        this.close();
      }

      onDialogClick(event) {
        if (event.target === this.dialog) this.close();
      }

      onDialogClose() {
        document.body.classList.remove('overflow-hidden');
        this.removeAttribute('data-pending-auto-open');
        if (this.hasAttribute('data-unlocked') && !this.hasAttribute('data-gift-in-cart')) {
          this.setAttribute('data-user-dismissed-unlock', '');
          this.openCartDrawer();
        }
      }

      onSwatchChange(event) {
        if (event.target?.type !== 'radio' || !event.target.closest('[data-gift-swatches]')) return;
        this.updateVariantUi();
      }

      selectDefaultSwatch() {
        const checked = this.querySelector('[data-gift-swatches] input[type="radio"]:checked');
        if (checked) return;
        const first = this.querySelector('[data-gift-swatches] input[type="radio"]:not([hidden]):not([disabled])');
        if (first) first.checked = true;
      }

      parseVariants() {
        try {
          return JSON.parse(this.querySelector('[data-gift-variants]')?.textContent || '[]');
        } catch (error) {
          return [];
        }
      }

      getSelectedOptions() {
        const selected = {};
        this.querySelectorAll('[data-gift-swatches] input[type="radio"]:checked').forEach((input) => {
          const position = Number(input.dataset.optionPosition);
          const value = input.dataset.optionValue || input.value;
          if (position === 1) selected.option1 = value;
          if (position === 2) selected.option2 = value;
          if (position === 3) selected.option3 = value;
        });
        return selected;
      }

      optionMatch(left, right) {
        if (left == null || right == null) return true;
        return String(left).trim().toLowerCase() === String(right).trim().toLowerCase();
      }

      resolveVariant() {
        const picker = this.querySelector('[data-gift-picker]');
        if (picker && typeof PastaelFreeGift !== 'undefined') {
          const variantId = PastaelFreeGift.resolveGiftVariantFromRoot(picker);
          if (variantId) {
            const filtered = PastaelFreeGift.getFilteredGiftVariants(picker);
            const match = filtered.find((item) => Number(item.id) === Number(variantId));
            if (match) return match;
          }
        }

        const variants = this.parseVariants();
        const selected = this.getSelectedOptions();
        return (
          variants.find((item) => {
            if (selected.option1 != null && !this.optionMatch(item.option1, selected.option1)) return false;
            if (selected.option2 != null && !this.optionMatch(item.option2, selected.option2)) return false;
            if (selected.option3 != null && !this.optionMatch(item.option3, selected.option3)) return false;
            return true;
          }) ||
          variants.find((item) => item.available) ||
          variants[0] ||
          null
        );
      }

      updateVariantUi() {
        const variant = this.resolveVariant();
        const hidden = this.querySelector('[data-gift-variant-id]');
        const imageEl = this.querySelector('[data-gift-image]') || this.querySelector('.pastael-gift-popup__card-image');
        if (hidden) hidden.value = variant?.id ? String(variant.id) : '';

        if (imageEl && variant?.image) {
          const large = variant.image.replace(/width=\d+/, 'width=700');
          const small = variant.image.replace(/width=\d+/, 'width=350');
          imageEl.src = large;
          imageEl.srcset = `${small} 350w, ${large} 700w`;
        }
      }

      onCartUpdate(event) {
        if (event?.source === 'pastael-gift-popup') return;
        this.refreshFromCart({ autoOpen: true, cartData: event?.cartData });
      }

      fetchCart() {
        const cartUrl = `${(window.routes?.cart_url || '/cart').replace(/\/$/, '')}.js`;
        return fetch(`${cartUrl}?v=${Date.now()}`, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' },
        }).then((response) => {
          if (!response.ok) throw new Error('Cart fetch failed');
          return response.json();
        });
      }

      refreshFromCart({ autoOpen = false, cartData = null } = {}) {
        const apply = (cart) => {
          if (!cart?.items) return;
          const previouslyUnlocked = this.hasAttribute('data-unlocked');
          this.applyCart(cart);
          if (
            autoOpen &&
            !previouslyUnlocked &&
            this.hasAttribute('data-unlocked') &&
            !this.hasAttribute('data-gift-in-cart')
          ) {
            this.queueAutoOpen();
          }
        };

        const hasFullCart =
          cartData && Array.isArray(cartData.items) && typeof cartData.item_count === 'number';

        if (hasFullCart) {
          apply(cartData);
          return Promise.resolve(cartData);
        }

        return this.fetchCart()
          .then(apply)
          .catch(() => {});
      }

      /** Called from PDP when gift progress newly completes (reliable auto-open). */
      notifyThresholdUnlocked(cartData = null) {
        if (this.hasAttribute('data-gift-in-cart')) return Promise.resolve();
        this.removeAttribute('data-user-dismissed-unlock');

        const run = (cart) => {
          if (!cart?.items) return;
          this.applyCart(cart);
          if (this.hasAttribute('data-unlocked') && !this.hasAttribute('data-gift-in-cart')) {
            this.queueAutoOpen();
          }
        };

        const hasFullCart =
          cartData && Array.isArray(cartData.items) && typeof cartData.item_count === 'number';

        if (hasFullCart) {
          run(cartData);
          return Promise.resolve();
        }

        return this.fetchCart().then(run).catch(() => {});
      }

      applyCart(cart) {
        const quantity = this.getQualifyingQuantity(cart.items);
        const hasGift = (cart.items || []).some((item) => {
          const props = item.properties || {};
          return props[PASTAEL_GIFT_POPUP_PROPERTY] === PASTAEL_GIFT_POPUP_PROPERTY_VALUE;
        });
        const threshold = this.threshold;
        const remaining = Math.max(threshold - quantity, 0);
        const unlocked = threshold > 0 && remaining === 0;
        const percent = threshold ? Math.min((quantity / threshold) * 100, 100) : 0;

        this.style.setProperty('--pastael-gift-popup-progress', `${percent}%`);
        this.toggleAttribute('data-unlocked', unlocked);
        this.toggleAttribute('data-gift-in-cart', hasGift);
        this.dialog?.classList.toggle('is-unlocked', unlocked);

        const headingLocked = this.querySelector('[data-gift-popup-heading-locked]');
        const template = this.dataset.headingTemplate || '';
        if (headingLocked && template) {
          headingLocked.textContent = pastaelFormatGiftRemainingText(template, remaining);
        }

        const addButton = this.querySelector('[data-gift-popup-add]');
        if (addButton) addButton.disabled = hasGift;

        if (!unlocked) {
          this.forgetAutoOpen();
          this.removeAttribute('data-user-dismissed-unlock');
        }
      }

      getQualifyingQuantity(items) {
        if (typeof PastaelFreeGift !== 'undefined' && PastaelFreeGift.getQualifyingGiftQuantity) {
          return PastaelFreeGift.getQualifyingGiftQuantity(
            items,
            new Set(this.productIds.map(String)),
            new Set(this.productHandles)
          );
        }

        const idSet = new Set(this.productIds.map(String));
        const handleSet = new Set(this.productHandles.map(String));
        if (!idSet.size && !handleSet.size) return 0;

        return (items || []).reduce((sum, item) => {
          const productId = String(item.product_id ?? item.productId ?? '');
          const productHandle = String(item.handle ?? item.product_handle ?? '');
          const matches = idSet.has(productId) || (productHandle && handleSet.has(productHandle));
          return matches ? sum + Number(item.quantity || 0) : sum;
        }, 0);
      }

      ensureDialogPortal() {
        if (this.dataset.portaled === 'true') return;
        document.body.appendChild(this);
        this.dataset.portaled = 'true';
      }

      queueAutoOpen() {
        if (this.hasAttribute('data-gift-in-cart')) return;
        if (this.dialog?.open) return;
        if (this.hasAttribute('data-user-dismissed-unlock')) return;
        this.setAttribute('data-pending-auto-open', '');
        window.requestAnimationFrame(() => this.open({ auto: true }));
      }

      openCartDrawer() {
        const cart = document.querySelector('cart-drawer');
        if (!cart || cart.classList.contains('active') || typeof cart.open !== 'function') return;
        cart.open();
      }

      open({ auto = false } = {}) {
        this.ensureDialogPortal();
        if (!this.dialog) return;
        if (this.dialog.open) return;

        this.refreshFromCart({ autoOpen: false });
        this.syncBagSizeFromPdp().finally(() => {
          this.enableSwatches();
          this.selectDefaultSwatch();
          this.updateVariantUi();
        });

        try {
          this.dialog.showModal();
        } catch (error) {
          console.error('[pastael-gift-popup] showModal failed', error);
          this.removeAttribute('data-pending-auto-open');
          return;
        }

        this.removeAttribute('data-pending-auto-open');
        document.body.classList.add('overflow-hidden');
        if (auto) this.rememberAutoOpen();
        this.dialog.querySelector('[data-gift-popup-close]')?.focus();
      }

      close() {
        if (!this.dialog?.open) return;
        this.dialog.close();
      }

      hasAutoOpened() {
        try {
          return sessionStorage.getItem(PASTAEL_GIFT_POPUP_AUTO_KEY) === '1';
        } catch (error) {
          return false;
        }
      }

      rememberAutoOpen() {
        try {
          sessionStorage.setItem(PASTAEL_GIFT_POPUP_AUTO_KEY, '1');
        } catch (error) {}
      }

      forgetAutoOpen() {
        try {
          sessionStorage.removeItem(PASTAEL_GIFT_POPUP_AUTO_KEY);
        } catch (error) {}
      }

      onAddClick(event) {
        event.preventDefault();
        const button = event.currentTarget;
        if (button.disabled || !this.hasAttribute('data-unlocked')) return;

        const variant = this.resolveVariant();
        if (!variant?.id || !variant.available) return;

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');

        const properties = {
          [PASTAEL_GIFT_POPUP_PROPERTY]: PASTAEL_GIFT_POPUP_PROPERTY_VALUE,
        };
        if (typeof PastaelFreeGift !== 'undefined') {
          PastaelFreeGift.appendGiftNotePropertyObject(properties, this.querySelector('[data-gift-picker]'));
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        const body = {
          items: [
            {
              id: Number(variant.id),
              quantity: 1,
              properties,
            },
          ],
        };

        if (this.cart?.getSectionsToRender) {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id).join(',');
          body.sections_url = window.location.pathname;
          this.cart.setActiveElement?.(document.activeElement);
        }

        config.body = JSON.stringify(body);

        fetch(`${window.routes?.cart_add_url || '/cart/add'}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) return;
            this.toggleAttribute('data-gift-in-cart', true);
            this.close();
            const pubSubEvents = window.PUB_SUB_EVENTS;
            if (typeof publish === 'function' && pubSubEvents?.cartUpdate) {
              publish(pubSubEvents.cartUpdate, {
                source: 'pastael-gift-popup',
                productVariantId: variant.id,
                cartData: response,
              });
            }
            this.cart?.renderContents?.(response);
          })
          .catch(() => {})
          .finally(() => {
            button.removeAttribute('aria-busy');
            if (!this.hasAttribute('data-gift-in-cart')) button.disabled = false;
          });
      }
    }
  );
}
